class Mobilenav {

    constructor() {
        this.mobileNavigation = $('.mobile-nav');
        this.mobileNavigationButton = $('#menu-toggle');
        this.body = $("body");
        this.isOpen = false;
        //console.log('drinne');
        //preserve context in functionscope
        const that = this;

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', () => {
            // We execute the same script as before
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        //OpenMenu
        $(this.mobileNavigationButton).on('click tap', function (e) {
            $(this).addClass("hamburger-open");
            if (that.isOpen) {
                that.closeMobileNavigation();
                $(this).removeClass("hamburger-open");
                that.body.removeClass('fixed-layer');
            } else {
                that.body.addClass('fixed-layer');
                that.openMobileNavigation();
            }
        });

        // unfold logic
        $('.mobile-nav__sub--btn').on('click tab', function (e) {
            const listElement = $(this).parent();
            if (listElement.hasClass('current')) {
                listElement.removeClass('current');
            } else {
                $(".mobile-nav__primary").removeClass('current');
                listElement.addClass('current');
            }
            e.preventDefault();
        });
    }

    openMobileNavigation() {
        //this approach is dependent on the sequence of the css classes
        const that = this;
        that.isOpen = true;
        that.mobileNavigationButton.attr('aria-expanded', true);
        //add transition on click to prevent side load animation
        that.mobileNavigation.addClass('mobile-nav__postload');
        that.mobileNavigation.addClass('mobile-nav__open');

    }

    closeMobileNavigation() {
        const that = this;
        that.isOpen = false;
        that.mobileNavigation.removeClass('mobile-nav__open');
    }
}
